import styles from './index.module.less'
import { useHomeStore } from '@/hoxStore/homeStore'
//--------------- 新增代码 ---------------
import Banner from './components/banner'
import DataBlockCard from './components/DataBlockCard'
import ViewCard from './components/ViewCard'
import LatestBlockCom from './components/LatestBlock'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { throttle } from '@/utils'
import { isEqual } from 'radash'
import { type Transition, type Block, type Stats } from '@/hoxStore/interface'
import eventBus, { IEventBus } from '@/utils/eventBus.ts'
import SocketConnetShow from '@/components/socketConnetShow'

const HomePage = () => {
  const { isReady, formattedMessage } = useHomeStore()
  /**
   * latestTranList 最新交易
   * latestBlockList 最新区块
   * stats 统计
   */
  const [latestTranList, setLatestTranList] = useState<Transition[]>([])
  const [latestBlockList, setLatestBlockList] = useState<Block[]>([])
  const [stats, setStats] = useState<Stats>({} as Stats)
  const [latestBlockComKey, setLatestBlockComKey] = useState(0)
  const [webSocketConnectShow, setWebSocketConnectShow] = useState(false)

  /** 节流 */
  const throttledUpdate = useRef(
    throttle((data: any) => {
      const latestTranList = data.transitions || [] // 最新交易
      const latestBlockList = data.blocks || [] // 最新区块
      const stats = data.stats || {} // 统计
      setLatestBlockList((prevBlockList) => {
        if (!isEqual(prevBlockList, latestBlockList)) {
          return latestBlockList
        }
        return prevBlockList
      })
      setLatestTranList((preTranList) => {
        if (!isEqual(preTranList, latestTranList)) {
          return latestTranList
        }
        return preTranList
      })
      setStats((preStats) => {
        if (!isEqual(preStats, stats)) {
          return stats
        }
        return preStats
      })
    }, 1000),
  ).current

  /**
   * 数据回来之后开始处理
   */
  useEffect(() => {
    if (isReady && formattedMessage) {
      throttledUpdate(formattedMessage)
    }
  }, [isReady, formattedMessage, throttledUpdate])

  const blocksAfterSort = useMemo(() => {
    const data = JSON.parse(JSON.stringify(latestBlockList || []))
    data.sort((a: Block, b: Block) => {
      return b.height - a.height
    })
    return data
  }, [latestBlockList])

  const handleWebSocketConnectShow = useCallback((value: boolean) => {
    if (!webSocketConnectShow) {
      setWebSocketConnectShow(value)
    }
  }, [])

  useEffect(() => {
    eventBus.on(IEventBus.WebSocketConnectShow, handleWebSocketConnectShow as () => void)
    return () => {
      eventBus.off(IEventBus.WebSocketConnectShow, handleWebSocketConnectShow as () => void)
    }
  }, [])

  return (
    <div className={styles.home_page}>
      {webSocketConnectShow && <SocketConnetShow />}
      <Banner />
      <DataBlockCard stats={stats} blocks={JSON.parse(JSON.stringify(latestBlockList || []))} />
      <ViewCard blocks={latestBlockList} transitions={latestTranList} />
      <LatestBlockCom
        key={latestBlockComKey}
        blocks={latestBlockList}
        transitions={latestTranList}
      />
      {/* <div className={styles.block_container}>
        <ViewCard blocks={latestBlockList} transitions={latestTranList} showRight />
        <LatestBlockCom
          key={latestBlockComKey}
          showRight
          blocks={latestBlockList}
          transitions={latestTranList}
        />
      </div> */}
    </div>
  )
}

export default HomePage
